export default __webpack_public_path__ + "static/media/tiffi1big.60c4843e.jpg";